import { loadStripe, type Stripe } from '@stripe/stripe-js'

/**
 * One Stripe.js instance per publishable key. Stripe.js is loaded from js.stripe.com only when a
 * billing surface that needs it opens; card data goes from the iframe straight to Stripe and never
 * through our API (BI2).
 */
const cache = new Map<string, Promise<Stripe | null>>()

export function stripeFor(publishableKey: string): Promise<Stripe | null> {
  let loaded = cache.get(publishableKey)
  if (loaded === undefined) {
    loaded = loadStripe(publishableKey)
    cache.set(publishableKey, loaded)
  }
  return loaded
}
